import { t } from "i18next";
import NoFilter from "../../../../DataTable/datatable.nofilter";
import { QualityValue } from "../../../../Types/LotDetailQuality";

export function QualityValueConfidenceColumn() {
    return {
        Header: t('LotDetails.Qualities.QualityValueConfidence'),
        accessor: 'confidence',
        Cell: (props: any) => {
            let result = props.row.original.qualityValues.find((qv: QualityValue) => qv.testMethod === "ASADDED");
            if (result == null)
                return "";  // No as-added result

            if (result.resultValue == null || result.resultValue === "")
                return "";  // No value for as-added result

            return result.status.substring(0, 2);
        },
        Filter: NoFilter
    };
}